import { render, staticRenderFns } from "./Dga.vue?vue&type=template&id=a30df8ca&"
import script from "./Dga.vue?vue&type=script&lang=ts&"
export * from "./Dga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports